/**
 *
 * RemoveDialogWarning Component
 *
 */

import React from "react";

import { stylize, Enums } from "@envestnet/envreact-component-library";
import withIntl from "utils/withIntl";
import TermsDialog from "components/TermsDialog";
import messages from "./messages";
import styles, { Styles } from "./styles";

interface InjectedProps extends Styles {
  /** Internal - injected from withIntl */
  formatMessage: FormatMessage;
}

interface DefaultProps {
  // Default props should always be required props, i.e. no ? indicating it's optional
  // The default values are specified below

  /** Description of this prop */
  open: boolean;
  showDefaultButton: boolean;
}

export interface RemoveDialogWarningProps extends DefaultProps {
  /** Description of this prop */
  setOpen: any;
  setSuccess: any;
  children: any;
}

const defaultProps: DefaultProps = {
  open: false,
  showDefaultButton: true,
};

type Props = InjectedProps & RemoveDialogWarningProps;

const RemoveDialogWarning = (props: Props) => {
  const {
    classes,
    formatMessage,
    open,
    setOpen,
    setSuccess,
    children,
    showDefaultButton,
  } = props;
  const buttons = showDefaultButton
    ? [
        {
          buttonType: Enums.ButtonStyle.Secondary,
          title: formatMessage(messages.cancelButtonLabel),
          id: formatMessage(messages.cancelButtonLabel),
          onClick: () => {
            setOpen(false);
          },
        },
        {
          buttonType: Enums.ButtonStyle.Primary,
          title: formatMessage(messages.save),
          id: formatMessage(messages.save),
          reachedBottom: false,
          onClick: () => {
            setSuccess(false);
          },
        },
      ]
    : [
        {
          buttonType: Enums.ButtonStyle.Primary,
          title: formatMessage(messages.tryAgain),
          id: formatMessage(messages.tryAgain),
          reachedBottom: false,
          onClick: () => {
            setSuccess(true);
          },
        },
      ];
  return (
    <TermsDialog
      open={open}
      onClose={() => {
        setOpen(false);
      }}
      styleObject={{ container: classes.container }}
      buttons={buttons}
      isSticky={false}
    >
      {children}
    </TermsDialog>
  );
};

RemoveDialogWarning.defaultProps = defaultProps;

export default withIntl(
  stylize<Props, DefaultProps>(styles)(RemoveDialogWarning)
);
